import React, { useEffect, useState } from "react";
import styles from "./support.module.css";
import Select from "react-select";
import PaginatedTable from "./supportTable";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { post } from "../../../components/api";
import Loading from "../../../components/Loading";
import { SweetAlert } from "../../../helpers/helper";
// import { Badge } from "react-bootstrap";
const SupportLoad = () => {
  const [show, setShow] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [tripId, setTipId] = useState("");
  const [saveLoading, setSaveLoading] = useState(false);
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [selectedStatus, setSelectedStatus] = useState({
    label: "open",
    value: "open",
  });

  const customStyles = {
    control: (base) => ({
      ...base,
      background: "rgba(245, 246, 250, 1)",
      border: "none",
      outline: "none",
      fontSize: "14px",
      color: "black",
    }),
    menuList: (base) => ({
      ...base,
      background: "rgba(245, 246, 250, 1)",
      fontSize: "14px",
    }),
    singleValue: (base) => ({
      ...base,
      color: "rgba(125, 139, 143, 0.5)",
      fontWeight: "bold",
      textAlign: "start",
    }),
    option: (base, state) => ({
      ...base,
      background: state.isSelected
        ? "white" // light blue when selected
        : state.isFocused
        ? "rgba(54, 153, 255, 0.05)" // lighter blue when hovered
        : "rgba(245, 246, 250, 1)",
      color: state.isSelected ? "rgba(125, 139, 143, 0.5)" : "black", // red for selected option
      cursor: "pointer",
      textAlign: "start",
    }),
  };
  // const customStyles = {
  //   control: (base) => ({
  //     ...base,
  //     background: "rgba(245, 246, 250, 1)",
  //     border: "none",
  //     outline: "none",
  //     fontSize: "14px",
  //     color: "black",
  //   }),
  //   menuList: (base) => ({
  //     ...base,
  //     background: "rgba(245, 246, 250, 1)",
  //     fontSize: "14px",
  //   }),
  // };

  const fetchData = async (page = 1, limit = 10) => {
    const response = await post("company/ltms/GetAllTicket", {
      page,
      limit,
      search,
      status: selectedStatus.label,
    });
    if (response.status == 200) {
      setData(response.data);
      setTotalRows(response.data.totalDocs);
    }
  };
  useEffect(() => {
    fetchData(currentPage, perPage);
  }, [currentPage, perPage]);
  const toggleModal = () => {
    setShow(!show);
  };

  const handleSelectStatus = (e) => {
    setSelectedStatus(e);
  };
  const handleSubmit = async () => {
    setSaveLoading(true);
    if (tripId && remarks) {
      const createRemarks = await post("company/ltms/Create_Ticket", {
        tripId: tripId,
        remarks: remarks,
      });
      if (createRemarks.status == 200) {
        setSaveLoading(false);
        setTipId("");
        setRemarks("");
        setShow(false);
        fetchData();
      } else {
        setSaveLoading(false);
        setTipId("");
        setRemarks("");
        setShow(false);
        SweetAlert(createRemarks.message || "error", true);
      }
    } else {
      setSaveLoading(false);
    }
  };
  const handleClose = () => {
    setShow(!show);
  };

  const handleSearch = () => {
    fetchData();
  };

  return (
    <>
      <div className={styles.Support}>
        <div className={styles.FirstCard}>
          <div className={styles.FirstCard_FirstDIv}>
            <div className={styles.FirstCard_FirstDIv_Div}>
              <input
                placeholder="Trip ID,Support ID"
                type="text"
                name="geofenceName"
                className={styles.input}
                autoComplete="off"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                maxLength={20}
              />
              <Select
                styles={customStyles}
                options={[
                  { label: "open", value: "open" },
                  { label: "close", value: "close" },
                ]}
                onChange={(e) => handleSelectStatus(e)}
                value={selectedStatus}
                className={styles.Select}
                maxMenuHeight={150}
                placeholder="Status"
                isSearchable={false}
              />
              <button className={styles.Submit_Button} onClick={handleSearch}>
                Search
              </button>
            </div>
            <div>
              <button className={styles.Raise_Ticket} onClick={toggleModal}>
                Raise Ticket
              </button>
            </div>
          </div>
        </div>
        <div className={styles.SecondCard}>
          <PaginatedTable
            data={data}
            page={currentPage}
            setPage={setCurrentPage}
            limit={perPage}
            setLimit={setPerPage}
            totalRows={totalRows}
          />
        </div>
      </div>
      <Modal show={show} onHide={handleClose} centered size="md">
        <Modal.Header closeButton>
          <Modal.Title>Raise Ticket</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={styles.Modal_Body}>
            <div>
              <p className={styles.modal_p}>Trip ID</p>
              <input
                placeholder="Trip ID,Support ID"
                type="text"
                name="Raise Ticket"
                className={styles.input}
                autoComplete="off"
                value={tripId}
                onChange={(e) => setTipId(e.target.value)}
                maxLength={20}
              />
            </div>
            <div>
              <p className={styles.modal_p}>Remarks</p>
              <textarea
                placeholder="Enter Remarks"
                type="textArea"
                name="Remarks"
                className={styles.textarea}
                autoComplete="off"
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
                maxLength={200}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className={styles.Submit_Button} onClick={handleSubmit}>
            {saveLoading ? <Loading /> : null}Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SupportLoad;
